export default "__VITE_ASSET__CHigeMTv__"